import React, { useMemo } from 'react'
import QualysInfraCredentialsForm from './QualysInfraCredentialsForm';
import QualysInfraMappingForm from './QualysInfraMappingForm';
import GenericPullConfigListing from '../GenericPullConfigListing';
import { columnRenderArrayData } from 'utils/tableUtils';

export default function QualysInfraConfigListing(props) {
    const columns = useMemo(() => [
        {   
            title: "Tag Name",
            dataIndex: "tagName",
            width: 240,
            render: (value) => value === "All" ? "All" : columnRenderArrayData(value)
        },{
            title: "Host Name",
            dataIndex: "hostName",
            width: 240,
            render: (value) => value === "All" ? "All" : columnRenderArrayData(value)
        }, {
            title: "Network Name",
            dataIndex: "networkName",
            width: 240,
            render: (value) => value === "All" ? "All" : columnRenderArrayData(value) 
        }
    ], [])

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={QualysInfraMappingForm}
            CredentialsForm={QualysInfraCredentialsForm}
            extraColumns={columns}
            displayComponentName="Host/Tag/Network"
        />
    )
}